// Module
var code = "<input id=\"{{inputId}}\" name=\"{{inputName}}\" ng-model=\"selectedItemText\" ng-bind=\"selectedItemText\" placeholder=\"{{placeholder}}\" autocomplete=\"off\" ng-transclude/> ";
// Exports
module.exports = code;